package com.sweetlime.bingeamigo.model

data class SearchResultItem(
    val id: Int,
    val title: String,
    val posterPath: String?,
    val voteAverage: Double,
)

fun Movie.toSearchResultItem() = SearchResultItem(id, title, posterPath, voteAverage)
fun TvShow.toSearchResultItem() = SearchResultItem(id, name, posterPath, voteAverage)